import {z} from 'zod';

// https://docs.mapbox.com/help/glossary/zoom-level/
export const zoomSchema = z.number().min(0).max(22);
